module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/338.e4220b36.png";